<!--
  ~ Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<form #platformLegalEntityInputsForm="ngForm" (ngSubmit)="onSubmit(platformLegalEntityInputsForm)">
  <div class="d-flex flex-column gap-3">
    <well-platform-company-registration-inputs [platformCompanyRegistrationDTO]="platformLegalEntityDTO?.companyRegistrationDTO" data-testid="platform-company-registration-inputs-input">
    </well-platform-company-registration-inputs>

    <well-platform-legal-entity-address-inputs [platformLegalEntityAddressDto]="platformLegalEntityDTO?.addressDTO" data-testid="platform-legal-entity-address-inputs-input">
    </well-platform-legal-entity-address-inputs>

    <well-platform-legal-entity-bank-account-inputs [platformLegalEntityBankAccountDto]="platformLegalEntityDTO?.bankAccountDTO" data-testid="platform-legal-entity-bank-account-inputs-input">
    </well-platform-legal-entity-bank-account-inputs>

    <well-platform-legal-entity-invoicing-terms-inputs [platformLegalEntityInvoicingTermsDTO]="platformLegalEntityDTO?.invoicingTermsDTO" data-testid="platform-legal-entity-invoicing-terms-inputs-input">
    </well-platform-legal-entity-invoicing-terms-inputs>

    <div class="d-flex flex-row space-between align-items-center-forced">
      <span>{{'utils.requiredLegend' | translate}}</span>
      <div class="d-flex flex-row justify-end">
        <button pButton label="{{'utils.back' | translate}}" type="button"
                class="mr-sm p-button-text" (click)="onCancel()" data-testid="on-cancel-btn"></button>
        <button type="submit" pButton label="{{'utils.save' | translate}}"
                class="p-button" data-testid="submit-btn"></button>
      </div>
    </div>
  </div>

</form>


